import { Box, Typography } from "@mui/material";
import React from "react";
import CreditCardIcon from "@mui/icons-material/CreditCard";

const CardPatment = ({ payment }) => {
  const formatDate = (date) => {
    const dateObj = new Date(date);

    const fechaFormateada = dateObj.toLocaleString("es-MX", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
    return fechaFormateada;
  };
  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        width: "95%",
        // paddingLeft: 1,
        paddingRight: 1,
        justifyContent: "space-between",
        "&:hover": {
          transform: "scale(1)", // Efecto de zoom
          boxShadow: "0 4px 20px rgba(0,0,0,0.5)", // Sombra más pronunciada
          cursor: "pointer", // Cambia el cursor
        },
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
        <CreditCardIcon sx={{ fontSize: 50, color: "#e7ef7d" }} />
        <Box>
          <Typography>{payment?.membershipType ?? "---"}</Typography>
          <Typography>
            Fecha de pago: {formatDate(payment?.paymentDate ?? "---")}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 4,
          alignItems: "center",
        }}
      >
        <Typography sx={{ color: "#e7ef7d", fontSize: 20 }}>
          ${payment?.amount ?? 0}
        </Typography>
      </Box>
    </Box>
  );
};

export default CardPatment;
